<br>
<div class="p-grid">
        <div class="col-sm" style="text-align: center;">
        <h1>Ponte en contacto con nosotros</h1>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm" style="text-align: center; margin-top: 10%;" >
            
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15959.102647240308!2d-78.5270162!3d-0.2649503!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x173c82b4345d163!2sClub%20de%20karate%20do%20Tigre%20Rojo!5e0!3m2!1ses-419!2sec!4v1609696892881!5m2!1ses-419!2sec" width="400" height="300" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
        <div class="col-sm" style="text-align: center;">
            <div class="row">
                <div class="col-sm">
                    <form>
                        <span style="width: 60%;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
                                class="bi bi-person-fill" viewBox="0 0 16 16">
                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                            </svg><label>&nbsp; &nbsp; Tu nombre</label>
                            <br>
                            <input class="contactosform" type="text" style="width: 60%;">
                        </span>
                        <br>
                        <span style="width: 60%;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
                                class="bi bi-telephone-fill" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                            </svg><label>&nbsp; &nbsp; Tu número de teléfono</label>
                            <br>
                            <input class="contactosform" type="text" style="width: 60%;">
                        </span>
                        <br>
                        <span style="width: 60%;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
                                class="bi bi-envelope-fill" viewBox="0 0 16 16">
                                <path
                                    d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z" />
                            </svg><label>&nbsp; &nbsp; Tu correo electrónico</label>
                            <br>
                            <input class="contactosform" type="email" style="width: 60%;">
                        </span>
                        <br>
                        <span style="width: 60%;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
                                class="bi bi-chat-left-text-fill" viewBox="0 0 16 16">
                                <path
                                    d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z" />
                            </svg><label>&nbsp; &nbsp; Tu mensaje</label>
                        </span>
                        <br>
                        <textarea name="mensaje" id="mensajeUsuario" cols="30" rows="6"
                            style="width: 60%; border-radius: 8px; height: 110px;"></textarea><br>
                        <button type="button" class="btn-enviar">Enviar Información</button>
        
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>